<template>
  <div class="loading-overlay-container">
    <!-- Opaque background -->
    <div class="loading-overlay-modal-background" />
    <!-- Inner body -->
    <div class="loading-inner-container">
      <h2 style="text-align: center;">
        {{ title }}
      </h2>
      <label
        class="subtitle padded"
        :class="{ colorError: error }"
      >{{
        errorMessage
      }}</label>

      <form
        id="hosted-fields-form"
        method="post"
        class="panel-body"
        style="margin-bottom: 0;"
      >
        <CreditCardForm @updateBillingAddress="updateBillingAddress" />
        <input
          id="payment-button"
          type="submit"
          value="Add Card"
          style="background-color:#34c263; color: #ffffff; border: none; margin-top: 30px; width: 100%; border-radius: 8px;"
          class="btn btn-success btn-lg center-block"
        >
      </form>
      <div
        v-if="showLoading"
        class="add-card-loading"
      >
        <img
          src="/assets/loading-animation.gif"
          alt="loading"
        >
      </div>
      <button
        style="max-width: 332px; margin: 0;"
        class="cancel-btn"
        @click="cancel()"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import CreditCardForm from '@/components/Forms/CreditCardForm'

/**
 * The Modal component for credit card form
 * @displayName Credit Card Form Modal
 */
export default {
	name: 'CreditCardFormModal',
	components: {
		CreditCardForm
	},
	props: ['cardValues', 'message'],
	data: function () {
		return {
			title: 'Add Card',
			showLoading: true,
			errorMessage: '',
			error: false,
			billing_address: ''
		}
	},
	computed: {
		/**
		 * To assert if Add Card button is disabled or not
		 *
		 * @public
		 */
		formIsValid () {
			// TODO: currently just checking if not empty, can validate better where needed
			if (this.cardValues.card_number === '') {
				return false
			}
			if (this.cardValues.billing_address === '') {
				return false
			}
			if (this.cardValues.billing_zip === '') {
				return false
			}
			if (this.cardValues.cvv2 === '') {
				return false
			}
			if (this.cardValues.expire_month === '') {
				return false
			}
			if (this.cardValues.expire_year === '') {
				return false
			}
			return true
		}
	},
	mounted: function () {
		var cmp = this
		let braintreeClientScript = document.getElementById('InjectedBraintreeClient')
		let braintreeHostedFieldsScript = document.getElementById('InjectedBraintreeHostedFields')

		if (braintreeClientScript && braintreeHostedFieldsScript) {
			cmp.createDropIn()
		} else {
			braintreeClientScript = document.createElement('script')
			braintreeClientScript.id = 'InjectedBraintreeClient'
			braintreeClientScript.setAttribute(
				'src',
				'https://js.braintreegateway.com/web/3.85.2/js/client.min.js'
			)

			braintreeHostedFieldsScript = document.createElement('script')
			braintreeHostedFieldsScript.id = 'InjectedBraintreeHostedFields'
			braintreeHostedFieldsScript.setAttribute(
				'src',
				'https://js.braintreegateway.com/web/3.85.2/js/hosted-fields.min.js'
			)

			braintreeHostedFieldsScript.onload = function () {
				cmp.createDropIn()
			}
			document.head.appendChild(braintreeClientScript)
			document.head.appendChild(braintreeHostedFieldsScript)
		}
	},
	unmounted: function () { },
	methods: {
		/**
		 * Gets called when user clicks cancel button
		 *
		 * @public
		 */
		cancel: function () {
			this.$emit('close')
		},
		/**
		 * Gets called when user clicks Add Card
		 *
		 * @public
		 */
		confirm: function () {
			this.$emit('confirm')
		},
		/**
		 * Gets called on change event of CreditCardForm billing_address input
		 *
		 * @public
		 */
		updateBillingAddress: function (str) {
			this.billing_address = str
		},
		/**
		 * Gets called onMount
		 *
		 * @public
		 */
		createDropIn () {
			var cmp = this
			cmp.braintreeIsThinking = true

			var apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'braintree_client_token'

			this.$store.dispatch('apiCall', apiPayload).then(response => {
				if (!response.data.payload || !response.data.payload.clientToken) {
					cmp.openDefaultError()
					return
				}
				var clientToken = response.data.payload.clientToken
				if (!clientToken.length) {
					cmp.openDefaultError()
					return
				}

				var form = document.querySelector('#hosted-fields-form')
				var submit = document.querySelector('input[type="submit"]')

				const braintree = window.braintree

				braintree.client.create({
					// Insert your tokenization key here
					authorization: clientToken
				}, function (clientErr, clientInstance) {
					if (clientErr) {
						cmp.openDefaultError()
						return
					}

					braintree.hostedFields.create({
						client: clientInstance,
						fields: {
							number: {
								container: '#card-number',
								placeholder: 'Card Number'
							},
							cvv: {
								container: '#cvv',
								placeholder: 'CVV'
							},
							expirationDate: {
								container: '#expiration-date',
								placeholder: 'Expiration Date'
							},
							postalCode: {
								selector: '#billing_zip',
								placeholder: 'Zip'
							}
						}
					}
						, function (hostedFieldsErr, instance) {
						if (hostedFieldsErr) {
							// console.error(hostedFieldsErr)
							return
						}
						// Once the fields are initialized enable the submit button
						submit.removeAttribute('disabled')
						cmp.showLoading = false

						// Initialize the form submit event
						form.addEventListener('submit', function (event) {
							event.preventDefault()
							cmp.showLoading = true
							cmp.errorMessage = ''
							cmp.error = false

							// When the user clicks on the 'Submit payment' button this code will send the
							// encrypted payment information in a variable called a payment method nonce
							instance.tokenize(function (tokenizeErr, payload) {
								if (tokenizeErr) {
									// console.error(tokenizeErr)
									cmp.showLoading = false
									cmp.errorMessage = tokenizeErr.message ? tokenizeErr.message : tokenizeErr
									cmp.error = true
									return
								}

								var apiPayload = {}
								apiPayload.apiEndpoint = 'account'
								apiPayload.postData = {}
								apiPayload.postData.action = 'add_card_braintree'
								apiPayload.postData.payment_nonce = payload.nonce
								// include street address
								apiPayload.postData.billing_address = cmp.billing_address

								cmp.$store.dispatch('apiCall', apiPayload).then(response => {
									cmp.showLoading = false
									if (response.data.payload && response.data.payload.success) {
										cmp.confirm()
									} else {
										cmp.errorMessage = response.data.message
										cmp.error = true
									}
								})
							})
						})
					}
					)
				})
			})
		}
	}
}
</script>

<style scoped>
.continue-btn {
	min-width: 130px !important;
	margin-right: 1rem;
}

.continue-btn .loading {
	margin: 0 auto;
	border-left-color: white;
	border-right-color: white;
	border-top-color: white;
}

.add-card-loading {
	background-color: rgb(255, 255, 255);
	position: absolute;
	top: 0%;
	min-width: 97%;
	min-height: 97%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.loading-inner-container {
	top: 10vh;
	left: 0;
	right: 0;
}

.padded {
	padding: 0 5em;
}

#hosted-fields-form {
	padding: 0 2.5em;
}</style>
